<!-- <p>tour-agencias-reservados works!</p> -->

<ul class="nav nav-tabs">
    
    <li class="nav-item">
        <a class="nav-link" [routerLink]="['/admin/tours-confirmados']" >Confirmados</a>        
    </li>

    <li class="nav-item pe-2">
        <a class="nav-link active" aria-current="page"  [routerLink]="['/admin/tours']" >Reservados</a>  
    </li>
</ul>
<div class="row">
    <div class="col-12 mt-4">
        <form [formGroup]="form" #f="ngForm" (ngSubmit)="onSubmit()" class="login">
            <div class="form-control p-0 position-relative">
                <input type="search" class="w-100 border-secondary" formControlName="search" placeholder="Buscar por pasajero o DNI">
                <img style="cursor: pointer;"  src="../assets/images/body/icons/search-icon.svg" class="position-absolute search-icon" (click)="onSubmit()" >
            </div>
        </form>
        
    </div>
    <!-- <div class="col-12 mt-4 d-flex">
        <div class="text-secondary rounded-pill border border-2 me-3 border-secondary btn-md btn-outline">
            Destino
        </div>
    </div> -->
</div>

<!-- agencias con reservaciones de un paquete determinado -->
<div *ngIf="agenciaDatos">
    <div class="d-flex align-items-baseline flex-lg-row flex-column mt-5">
        <h2 class="pe-lg-3">{{agenciaDatos.nombre_agencia}}</h2>
        <p class="mb-0 ">Vendedor: {{agenciaDatos.nombre_vendedor}}</p>  <!-- Todo verificar que informacion va aca -->
    </div>
    <div class="d-flex flex-lg-row flex-column justify-content-lg-between mt-4">
        <h4 class="title-bg">Pasajeros con reservas</h4>
        <a style="cursor: pointer;"  (click)=" openModalPasajerosConfirmados()" class="btn btn-lg rounded-pill btn-outline-secondary border-2 text-center btn-reservar align-self-lg-center align-self-baseline mt-lg-0">Aprobar todos</a>
    </div>
    <div class="mt-4">
        <div *ngFor="let pasajero of filtered">  <!-- *ngFor="let item of filtered" -->
            <!-- <div *ngFor="let pasajero of item.pasajeros"> -->
                <div *ngIf="pasajero.estado === 1" class="pasajero-admin bg-light d-md-flex flex-wrap flex-lg-row align-items-center justify-content-between p-3 mb-3">
                    <div class="d-flex align-items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="pe-3" width="50" height="50" viewBox="0 0 40 40">
                            <g transform="translate(-120 -306)"><path d="M20,0h0A20,20,0,0,1,40,20v0A20,20,0,0,1,20,40H0a0,0,0,0,1,0,0V20A20,20,0,0,1,20,0Z" 
                                transform="translate(120 306)" class="fondo" fill="#00008b"/>
                                <path d="M16.789,16.789a5.394,5.394,0,1,0-5.394-5.394A5.393,5.393,0,0,0,16.789,16.789Zm0,2.7C13.188,19.486,6,21.293,6,24.88v2.7H27.577v-2.7C27.577,21.293,20.389,19.486,16.789,19.486Z"
                                transform="translate(123.211 309.211)" class="icono" fill="#fff"/>
                            </g>
                        </svg>
                        <h5 class="mb-0 text-center">{{pasajero.nombre_pasajero}}</h5>
                    </div>
            
                    <div class="mt-4 mt-lg-0 d-flex">
                        <a style="cursor: pointer;"  (click)="verPlanilla(pasajero.id)"  class="me-2 mb-0 mb-lg-0 btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center">Ver planilla</a>
                        
                        
                        <a  class=" d-md-none me-2 mb-0 mb-lg-0 text-white text-center btn-reservar align-self-center"><img src="../assets/images/body/icons/aceptar-agencia.svg" alt=""></a>
                        <a  class=" d-md-none text-white text-center btn-reservar align-self-center"><img src="../assets/images/body/icons/cancelar-agencia.svg" alt=""></a>
            
                        <a style="cursor: pointer;"  (click)=" openModalPasajeroConfirmado(pasajero.id)"  class="d-none d-md-flex me-2 mb-3 mb-lg-0 btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center">Aprobar</a>
                        <a style="cursor: pointer;"  (click)=" openModalPasajeroeliminado(pasajero.id)" class="d-none d-md-flex btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center">Dar de baja</a>
                    </div>
                </div>
            <!-- </div> -->

        
        </div>
   </div>
</div>

    
